import {Component, OnInit} from '@angular/core';
import {MatFormField, MatLabel} from '@angular/material/form-field';
import {MatOption, MatSelect} from '@angular/material/select';
import {MatDialogContent, MatDialogRef} from '@angular/material/dialog';
import {MatCardTitle} from '@angular/material/card';
import {MatInput} from '@angular/material/input';
import {MatButton} from '@angular/material/button';
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {RejectOrderStatusEnum} from '../../../../enums/reject-order-status.enum';
import {EnumService} from '../../../../services/enum.service';

@Component({
    selector: 'app-reject-form',
    standalone: true,
    imports: [
        MatFormField,
        MatSelect,
        MatOption,
        MatDialogContent,
        MatCardTitle,
        MatInput,
        MatLabel,
        MatButton,
        ReactiveFormsModule
    ],
    templateUrl: './reject-form.component.html',
    styleUrl: './reject-form.component.scss'
})
export class RejectFormComponent implements OnInit {
    rejectForm: FormGroup;
    protected readonly RejectOrderStatusEnum = RejectOrderStatusEnum;

    constructor(private fb: FormBuilder, protected enumService: EnumService, private dialogRef: MatDialogRef<RejectOrderStatusEnum>) {
        this.rejectForm = this.fb.group({
            rejectReason: ['', Validators.required],
            rejectDescription: [''],
        });
    }

    ngOnInit(): void {
        let isUpdating = false;

        // установка валидатора для иной причины отмены
        this.rejectForm.valueChanges.subscribe(value => {
            if (isUpdating) {return;}

            isUpdating = true;
            const descriptionControl = this.rejectForm.controls['rejectDescription'];

            descriptionControl.clearValidators();

            if (value.reason === RejectOrderStatusEnum.other) {
                descriptionControl.setValidators(Validators.required);
            }

            descriptionControl.updateValueAndValidity();
            isUpdating = false;
        });
    }

    onSubmit(): void {
        this.dialogRef.close(this.rejectForm.value);
    }

    onCancel(): void {
        this.dialogRef.close();
    }

}
